import { Grid, Box, Checkbox, FileUploadList, FileUploadTrigger, Select, SelectContent, SelectItem } from "@dextech-ai/dex-design-system";
import { ReactComponent as BlueIconInfo } from '@/assets/svgs/blue-icon.svg';
import { assetUrl } from '@/utils/asset-url';
import { ReactComponent as IconRequestDocument } from '@/assets/svgs/document-request.svg';
import Button from "@/components/Button/index";
import { ReactComponent as IconUploadDocument } from '@/assets/svgs/document-upload.svg';
import FileUpload from '@/dsComponents/fileUpload';
import StatusLabel from "@/components/StatusLabel/index";
import Toast from '@/components/Toast';
// [DS-MIGRATION] legacy Breadcrumbs - replaced by DS-backed Breadcrumb. Remove in follow-up PR.
// import Breadcrumbs from "@/componentsDS/Breadcrumbs/index";
import Breadcrumb from '@/dsComponents/Breadcrumb';
import Modal, { MEDIUM_MODAL_WIDTH } from "@/dsComponents/Modal";
import { ModalBody, ModalFooter, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { InfoOutlined } from "@dextech-ai/dex-design-system/icons";
import { useBuildex } from "@/hooks/use-buildex/index";
import useModal from "@/hooks/use-modal/index";
import usePage from "@/hooks/use-page";
import usePersonas from '@/hooks/use-personas';
import useSGTDEnrollmentRequest from "@/hooks/use-sgtd-enrollment-request/index";
import useToast from '@/hooks/use-toast';
import { useParams } from "@/lib/router-dom";
import api from '@/services/api/sgtdEnrollmentRequest.js';
import { getDexConfig } from "@/utils/get-dex-config";
import { getEnvAndDex } from "@/utils/get-env-and-dex";
import titleCase from '@/utils/title-case';
import { produce } from "immer";
import { uniqBy } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import ReactDOM from 'react-dom';
import { useFeature } from "@/hooks/use-feature/index.js";
import { renderUserEmailInline } from '@/utils/formatUserEmail';
import { featureConstant } from "@/constants/configuration/feature";
import { findItem, renderSelectItems, selectedItemId } from "@/utils/select-items";
import { useTradex } from "@/hooks/use-tradex/index";
import { useHciImprovement } from "@/hooks/use-hci-improvement";
import { useHealthdex } from "@/hooks/use-healthdex/index";
import ApprovalRequestModal from '@/dsComponents/ApprovalRequestModal';

const Page = () => {

	/*=================================================1
		General
	/================================================*/
	const isSoftDeleteUserEnabled = useFeature(featureConstant.SOFT_DELETE_USER);
	const { dex } = getEnvAndDex();
	const dexConfig = getDexConfig(dex);
	const isBuildex = useBuildex();
	const isTradex = useTradex();
	// isHealthdex still drives non-HCI healthdex behaviour (the action-menu
	// filter below); only the HCI Code row is behind the rollout flag.
	const isHealthdex = useHealthdex();
	const isHciEnabled = useHciImprovement();

	const [pageTitle, setPageTitle] = useState(`${dexConfig.dexName} Enrolment Request`);
	usePage({ title: pageTitle });

	const{ requestId, useCaseId, orgId } = useParams()

	const status = {
		pending: "PENDING_APPROVAL",
		approve: "APPROVED",
		reject: "REJECTED",
		sign: "SIGN_DSA",
		requestInfo: "REQUEST_FOR_INFO"
	}

	const toastType = {
		success: "success",
		error: "error"
	}

	const actionType = {
		approve: "APPROVE",
		reject: "REJECT",
		info: "INFO",
		sign: "DSA"
	}

	const [dataAgreement, setDataAgreement] = useState(false)
	const [files, setFiles] = useState([])

	const [loading, setLoading] = useState(false)
	const [loadingMessage, setLoadingMessage] = useState(null)

	//================================================
	// Text Conversion
	//================================================

	function convertToDisplay(text){
		if (text === "DSA_REQUESTED") return "Sign DSA"
		if (text === "SIGN_DSA") return "Sign DSA"
		if (text === "INFO_REQUESTED") return "Request for Info"
		if (text === "PENDING") return "Pending Approval"

		const str = text?.split("_")
		return str?.map((str)=> titleCase(str)).join(" ")
	}

	//================================================*/
	// Modal
	//================================================*/
	const { visible: visibleConfirmation, show: showConfirmation, hide: hideConfirmation } = useModal();
	const { visible: visibleInfo, show: showInfo, hide: hideInfo } = useModal();

	const [action, setAction] = useState("")
	const [rejectReason, setRejectReason] = useState("")
	const [requestInfo, setRequestInfo] = useState("")

	/*=================================================
	  API
	/================================================*/

	const { toastList, addToastMessage } = useToast()
	const { items:personaList, fetch:fetchPersonaList, find, setItems:setPersonaList } = usePersonas()
	const { find:getRequest, items:requestItem, setItems:setRequestItem, error: errorRequestList, useCase, personaItems, setPersonaItems, getConfig, myInfoConfig} = useSGTDEnrollmentRequest();

	const getData = {
		useCaseId: useCaseId
	}

	const breadcrumbsItems = useMemo(() => {
		return [
			{
				label: '',
				link: `/`,
			},
			{
				label: 'Approval Requests',
				link: `/admin/approval-requests`
			},
			{
				label: `${dexConfig.dexName} Enrolment Request`,
				link: ``
			},
		]
	}, [dexConfig])

	useEffect(()=>{
		getConfig()
		getRequest(requestId)
		fetchPersonaList(getData)
	},[])

	useEffect(()=>{
		if (requestItem.status === status.approve && requestItem.user?.organization?.dataSharingUrl){
			return setDataAgreement(true)
		}

		setDataAgreement(false)
	},[requestItem])

	/*=================================================
	  myInfo Config
	/================================================*/

	function companyAppointment(value){
		const config = myInfoConfig?.companyAppointment?.filter((item) => {
			return item.value === value}).map((item)=> item.name)

		return config
	}

	function companyStatus(value){
		const config = myInfoConfig?.companyStatus?.filter((item) => {
			return item.value === value}).map((item)=> item.name)

		return config
	}

	function companyTypes(value){
		const config = myInfoConfig?.companyTypes?.filter((item) => {
			return item.value === value}).map((item)=> item.name)

		return config
	}

	function countryOfIncorp(value){
		const config = myInfoConfig?.countryOfIncorp?.filter((item) => {
			return item.value === value}).map((item)=> item.name)

		return config
	}

	function nationality(value){
		const config = myInfoConfig?.nationality?.filter((item) => {
			return item.value === value}).map((item)=> item.name)

		return config
	}

	/*=================================================
	  Status Dropdown
	/================================================*/
	const[statusPlaceHolder, setStatusPlaceHolder] =useState("Select Status")

	const [ options, setOptions ] = useState(["Approved", "Request for Info", "Sign DSA", "Rejected"])

	useEffect(()=>{

		if (dataAgreement === false && files.length === 0){
			return setOptions(["Approved", "Request for Info", "Sign DSA", "Rejected"])
		}

		if (dataAgreement === true && files.length > 0){
			return setOptions(["Approved", "Request for Info", "Sign DSA", "Rejected"])
		}

		return setOptions(["Request for Info", "Sign DSA", "Rejected"])

	},[dataAgreement, files])

	const handleStatusSelected = (option) =>{
		setStatusPlaceHolder(option)

		if (option === "Approved") return setAction("APPROVE")
		if (option === "Rejected") return setAction("REJECT")
		if (option === "Request for Info") return setAction("INFO")
		if (option === "Sign DSA") return setAction("DSA")
		return setAction("")
	}

	async function submitStatus(){

		if (statusPlaceHolder === "Select Status"){
			return
		}

		setStatusPlaceHolder("Select Status")
		setRejectReason("")
		setRequestInfo("")

		if (action === actionType.info ) return showInfo()

		if (action === actionType.approve || action === actionType.reject ) return showConfirmation()


		if (action === actionType.sign){
			setLoading(true)
			const [error, result] = await api.changeOrgAndAdminReqStatus(orgId, "DSA_REQUESTED", requestId)

			if (error) {
				return addToastMessage(error?.message, toastType.error)
			}
			setLoading(false)
			return getRequest(requestId)
		}
	}


	/*=================================================
	  Persona Selection
	/================================================*/

	const[personaPlaceHolder, setPersonaPlaceHolder] = useState("Select Persona(s)")
	const[newPersona, setNewPersona] = useState({})

	function handleSelected(option){
		setPersonaPlaceHolder(option.name)
		setNewPersona({id:option.id, name:option.name, $selected: true})
	}

	const handleUpdatePersonaSelect = (item) => {

		if (requestItem?.status === status.approve || requestItem?.status === status.reject){
			return
		}

		const index = personaItems?.findIndex(persona => persona.id === item.id);
		const updatedItems = produce(personaItems, draft => {
			draft[index].$selected = !draft[index].$selected
		})

		setPersonaItems(updatedItems)
	}

	function addPersona(){

		if (personaPlaceHolder==="Select Persona(s)"){
			return
		}

		const uniqPersona = uniqBy([...personaItems,newPersona],"id")
		setPersonaItems(uniqPersona)
		setPersonaPlaceHolder("Select Persona(s)")
	}

	const isRequestClosed = requestItem?.status === status.approve || requestItem?.status === status.reject

	/*=================================================
		Data Agreement Upload
	/================================================*/

	function handleDataAgreementSelect(){
		if (requestItem?.status === status.approve || requestItem?.status === status.reject){
			return
		}

		setDataAgreement(!dataAgreement)
	}

	/*=================================================
		API Action Functions
	/================================================*/

	async function requestAction(){
		const enrolledPersona = personaItems?.filter(persona=> persona.$selected === true).map(persona => {
			return persona.id
		})
		if(loading){
			return
		}

		if (action === actionType.approve){

			setLoading(true)
			if(files.length > 0){
				setLoadingMessage("Getting Upload URL...")
				const [getUrlError, urlResult] = await api.getUrl( orgId, files , 'data-sharing-agreement')
				if (getUrlError) {
					setLoadingMessage(null)
					setLoading(false)
					return addToastMessage(getUrlError?.message, toastType.error)
				}
				setLoadingMessage("Uploading file to server...")
				const [uploadError, uploadResult] = await api.uploadFile( urlResult.uploadURL, files)
				if (uploadError) {
					setLoadingMessage(null)
					setLoading(false)
					return addToastMessage(uploadError?.message, toastType.error)
				}
				setLoadingMessage("Scanning file for virus...")
				const [savingError, savingResult] = await api.scanAndSave( urlResult.key, orgId, 'data-sharing-agreement')
				if (savingError) {
					setLoadingMessage(null)
					setLoading(false)
					return addToastMessage(savingError?.message, toastType.error)
				}
			}

			const payload = {
				"personaIds": enrolledPersona
			}

			const [error, result] = await api.changeOrgAndAdminReqStatus(orgId, "APPROVED", requestId, payload)

			setLoadingMessage(null)
			setLoading(false)

			if (error) {
				return addToastMessage(error?.message, toastType.error)
			}

			getRequest(requestId)
			return addToastMessage("You have successfully approved the request.", toastType.success)
		}

		if (action === actionType.reject){
			setLoading(true)
			const payload = {
				"comment": rejectReason.length > 0 ? rejectReason : " "
			}

			const [error, result] = await api.changeOrgAndAdminReqStatus(orgId, "REJECTED", requestId, payload)

			setLoading(false)
			if (error) {
				return addToastMessage(error?.message, toastType.error)
			}

			setRejectReason("")
			getRequest(requestId)
			return addToastMessage("You have rejected the request.", toastType.success)

		}

		if (action === actionType.info){
			setLoading(true)
			const payload = {
				"comment": requestInfo
			}

			const [error, result] = await api.changeOrgAndAdminReqStatus(orgId, "INFO_REQUESTED", requestId, payload)

			setLoading(false)
			if (error) {
				return addToastMessage(error?.message, toastType.error)
			}

			setRequestInfo("")
			return getRequest(requestId)

		}

	}

	return (
		<>
			{/* [DS-MIGRATION] legacy Breadcrumbs - replaced by DS-backed Breadcrumb. Remove in follow-up PR. */}
			{/* <Breadcrumbs breadcrumbItems={breadcrumbsItems} /> */}
			<Breadcrumb items={breadcrumbsItems} />
			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">
						{dexConfig.dexName} Enrolment Request
					</div>
				</div>
			</div>
			<hr />

			<Grid columns={{ xs: 'minmax(0, 1fr)', md: 'minmax(0, 1fr) 368px' }} columnGap={0} minH="100vh" mt={1}>
				<Box flex="1 1 0%" mr={6}>
					<div className="layout-data-elements__block">
						<Box display="flex" align="center">
							<div className="enrolment-request-left__header-icon"><IconRequestDocument /></div>
							<div className="enrolment-request-left__header-desc">
								<div className="enrolment-request__title">{requestItem?.user?.firstName}</div>
								{/* <div className="enrolment-request__title">{requestItem?.user?.firstName} {requestItem?.user?.lastName}</div> */}
								<div className="enrolment-request__title--normal">{moment(requestItem?.created).format("D MMM YYYY, h:mm A")}</div>
							</div>
						</Box>
						<div className="enrolment-request-left__subheader">{`User has submitted a request for ${requestItem?.user?.organization?.name} to join ${dexConfig.dexName}. Please review the details:`}</div>
						<div className="enrolment-request-left__content">
							<div className="enrolment-request-left__title">Requestor</div>
							<Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Full Name</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.firstName}</div>
								{/* <div className="enrolment-request-left__info">{requestItem?.user?.firstName} {requestItem?.user?.lastName}</div> */}
							</Box>
							<Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Email</div>
								<div className="enrolment-request-left__info">{isSoftDeleteUserEnabled ? renderUserEmailInline(requestItem?.user) : requestItem?.user?.email} </div>
							</Box>
							<Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Mobile Number</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.mobileNumber}</div>
							</Box>
						</div>

						<div className="enrolment-request-left__content">
							<div className="enrolment-request-left__title">Company Information</div>
							<Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Company Name</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.organization?.name}</div>
							</Box>
							<Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Company Registration No./ UEN</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.organization?.uen}</div>
							</Box>
							{isHciEnabled && <div className="enrolment-request-left__text">
								<div className="enrolment-request-left__label">HCI Code</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.organization?.hciCode || "—"}</div>
							</div>}
							<Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Company Type</div>
								<div className="enrolment-request-left__info">{companyTypes(requestItem?.user?.organization?.companyType)}</div>
							</Box>
							<Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Date of Incorporation</div>
								<div className="enrolment-request-left__info">{moment(requestItem?.user?.organization?.incorporationDate).format("D MMM YYYY")}</div>
							</Box>
							<Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Country of Incorporation</div>
								<div className="enrolment-request-left__info">{countryOfIncorp(requestItem?.user?.organization?.countryofIncorporation)}</div>
							</Box>
							{isTradex && <Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Company Status</div>
								<div className="enrolment-request-left__info">{companyStatus(requestItem?.user?.organization?.companyStatus)}</div>
							</Box>}
							<Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Company Registered Address</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.organization?.registeredAddress}</div>
							</Box>
						</div>

						<div className="enrolment-request-left__content">
							<div className="enrolment-request-left__title">Appointments</div>
							<Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Name</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.organization?.appointmentName}</div>
							</Box>
							<Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Nationality</div>
								<div className="enrolment-request-left__info">{nationality(requestItem?.user?.organization?.appointmentNationality)}</div>
							</Box>
							<Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Email Address</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.organization?.appointmentEmail}</div>
							</Box>
							<Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Mobile Number</div>
								<div className="enrolment-request-left__info">{requestItem?.user?.organization?.appointmentMobile}</div>
							</Box>
							<Box display="flex" align="center" mt={2}>
								<div className="enrolment-request-left__label">Company Appointment</div>
								<div className="enrolment-request-left__info">{companyAppointment(requestItem?.user?.organization?.appointmentPosition)}</div>
							</Box>
						</div>

					</div>
				</Box>

				<Box minW="368px" maxW="368px">
					<div className="layout-enrolment-request__block">
						<div className="layout-enrolment-request__header">
							<Box pt={8} pb={6} px={8}>
								<div className="enrolment-request__title">
									Application Status
								</div>
							</Box>
						</div>
						<Box pt={8} pb={6} px={8}>
							<div className="enrolment-request__title">
								Current Status
							</div>

							<Box mb={4}>
								<Box my={3}>
									<StatusLabel text={convertToDisplay(requestItem?.status)} itemStatus={requestItem?.status}/>
								</Box>
								<div className="enrolment-request__title--small">
									Change the status of application
								</div>
							</Box>

							<div className="enrolment-request__dropdown-container">
								<div className="enrolment-request__select">
									<Select
										placeholder="Select Status"
										data-testid="status-option"
										value={statusPlaceHolder === "Select Status" ? null : statusPlaceHolder}
										onChange={handleStatusSelected}
										disabled={isRequestClosed}
									>
										<SelectContent>
											{options.filter(option => !((isBuildex || isHealthdex) && (option === "Request for Info" || option === "Sign DSA")))
											.map((option)=>(
												<SelectItem key={option} value={option}>{option}</SelectItem>
											))}
										</SelectContent>
									</Select>
								</div>
								<Button full maxWidth="80" text="Submit" disabled={!(requestItem?.status !== status.approve && requestItem?.status !== status.reject)} submit={() => submitStatus()}/>
							</div>
						</Box>
					</div>

					{isTradex && <div className="layout-enrolment-request__block">
						<div className="layout-enrolment-request__header">
							<Box pt={8} pb={6} px={8}>
								<div className="enrolment-request__title--small">
									Use Case
								</div>
								<div className="enrolment-request__title">
									{useCase?.useCaseTitle}
								</div>
							</Box>
						</div>
						<Box pt={8} pb={6} px={8}>
							<div className="enrolment-request__title">
								Selected Personas
							</div>
							<div className="enrolment-request__title--small">
								Add or remove relevant personas for the company
							</div>
							{requestItem?.organizationUseCases?.length !==0 && (
								<div className="enrolment-request__card">
									<div className="card-configure__icon enrolment-request__card-icon"><BlueIconInfo  className="enrolment-request__icon__blue"/></div>
									<div className="enrolment-request__title--small enrolment-request__title-custom" style={{marginTop:"-18px"}}>Enabled Agent - Principal Function</div>
								</div>
							)}
							{requestItem?.status===actionType.approve && (
								<div  className="enrolment-request__card">
								<div className="card-configure__icon enrolment-request__card-icon"><BlueIconInfo  className="enrolment-request__icon__blue"/></div>
								<div className="enrolment-request__title--small enrolment-request__title-custom">Transactions on behalf of external participants enabled.</div>
								</div>
							)}
							<Box mb={4}>
								{personaItems?.map((item,index)=>{
									return(
										<Box display="flex" mb={2} key={index}>
											<Checkbox data-testid="checkbox-element" checked={!!item.$selected} onCheckedChange={()=>handleUpdatePersonaSelect(item)} disabled={!(requestItem?.status !== status.approve && requestItem?.status !== status.reject)}>
												<span className="enrolment-request__desc">{item.name}</span>
											</Checkbox>
										</Box>
									)
							})}
							</Box>
							<div className="enrolment-request__dropdown-container">
								<div className="enrolment-request__select">
									<Select
										placeholder="Select Persona(s)"
										data-testid="persona-option"
										value={personaPlaceHolder === "Select Persona(s)" ? null : selectedItemId(personaList, newPersona.id)}
										onChange={(id) => handleSelected(findItem(personaList, id))}
										disabled={isRequestClosed}
									>
										<SelectContent>{renderSelectItems(personaList, { withAll: false })}</SelectContent>
									</Select>
								</div>
								<Button full maxWidth="60" text="Add" disabled={!(requestItem?.status !== status.approve && requestItem?.status !== status.reject)} submit={() => addPersona()}/>
							</div>
						</Box>
					</div>}

					{isTradex && <div className="layout-enrolment-request__block">
						<div className="layout-enrolment-request__header">
							<Box pt={8} pb={6} px={8}>
								<div className="enrolment-request__title">
									Data Sharing Agreement
								</div>
							</Box>
						</div>
						<Box pt={8} pb={6} px={8}>
							<Box display="flex" mb={2}>
								<Checkbox data-testid="checkbox-element" checked={!!dataAgreement} onCheckedChange={()=>handleDataAgreementSelect()} disabled={!(requestItem?.status !== status.approve && requestItem?.status !== status.reject)}>
									<span className="enrolment-request__desc">I confirm that the participant has submitted their Data sharing agreement</span>
								</Checkbox>
							</Box>

							<FileUpload
								files={files}
								onFilesChange={setFiles}
								accept=".pdf"
								typeErrorMessage="File type must be doc and pdf."
								maxFiles={1}
								disabled={!(requestItem?.status !== status.approve && requestItem?.status !== status.reject)}
							>
								{files.length === 0 && (
									<div className="enrolment-request__upload-doc">
										<div className="enrolment-request__selection-container"><IconUploadDocument /></div>
										<FileUploadTrigger asChild>
											<Button full maxWidth="104" text="Upload Copy" />
										</FileUploadTrigger>
										<div className='enrollmentDropZone__footnote'>Accepted file formate: <strong>.pdf</strong></div>
									</div>
								)}
								<FileUploadList listType="text" />
							</FileUpload>
						</Box>
					</div>}
				</Box>
			</Grid>

			<ApprovalRequestModal
				visible={visibleConfirmation}
				hide={hideConfirmation}
				title={`${titleCase(action)} Request`}
				isApprove={action === actionType.approve}
				isReject={action === actionType.reject}
				onRejectReasonChange={setRejectReason}
				onConfirm={requestAction}
			/>

			<Modal width={MEDIUM_MODAL_WIDTH} visible={visibleInfo} close={hideInfo}>
				<ModalHeader icon={<InfoOutlined data-ds-color="primary-dark" />}>
					<ModalTitle>Request for Info</ModalTitle>
				</ModalHeader>
				<ModalBody>
					<div>
						<div className="action-modal__text">
							Please specify what you require from the participant. An email will be sent to the requestor.
						</div>
						<textarea className="action-modal__rejection-textarea" placeholder="Information required (Mandatory)" onChange={(e)=> setRequestInfo(e.target.value)}></textarea>
					</div>
				</ModalBody>
				<ModalFooter>
					<ModalFooterRight>
						<Button full maxWidth="80" text="Submit"
							submit={() => {
								hideInfo()
								requestAction()
							}}
							disabled={!(requestInfo.length > 0)}
						/>
					</ModalFooterRight>
				</ModalFooter>
			</Modal>
			<Toast toastList={toastList} />

			{
				loading && (
					ReactDOM.createPortal(
						<div className='modal white'>
								{
									loadingMessage && (
										<>
											<div className='loading' style={{flexDirection: 'column'}}>
												<img src={assetUrl("/img/loading.gif")} />
												<p style={{color: 'white'}}>{loadingMessage}</p>
											</div>
										</>
									)
								}
								{
									!loadingMessage && (
										<>
											<div className='loading' >
												<img src={assetUrl("/img/loading.gif")} />
											</div>
										</>
									)
								}

						</div>
						, document.body
					)
				)
			}
		</>
	);
};

export default Page;
